import GoalLine from "./GoalLine";
export default GoalLine;
